(function () {
  var root = document.getElementById('CapContactHelp');
  if (!root || root.dataset.capReady === '1') return;
  root.dataset.capReady = '1';

  var pageType = root.dataset.pageType || document.body.className || '';
  var whatsappUrl = root.dataset.whatsappUrl;
  var phoneUrl = root.dataset.phoneUrl;
  var template = document.getElementById('CapContactHelpBannerTemplate');

  if (!template) return;

  function text(el, value) {
    if (el && value) el.textContent = value;
  }

  function wireLinks(el) {
    el.querySelectorAll('[data-cap-action="whatsapp"]').forEach(function (a) {
      a.href = whatsappUrl;
      a.target = '_blank';
      a.rel = 'noopener';
    });
    el.querySelectorAll('[data-cap-action="phone"]').forEach(function (a) {
      a.href = phoneUrl;
    });
  }

  function makeBanner(config) {
    var fragment = template.content.cloneNode(true);
    var banner = fragment.querySelector('[data-cap-help-banner]');
    if (!banner) return null;

    if (config.variant) banner.classList.add('cap-help-banner--' + config.variant);
    text(banner.querySelector('[data-cap-help-eyebrow]'), config.eyebrow);
    text(banner.querySelector('[data-cap-help-title]'), config.title);
    text(banner.querySelector('[data-cap-help-text]'), config.body);
    wireLinks(banner);
    return banner;
  }

  function alreadyPlaced(key) {
    return document.querySelector('[data-cap-help-instance="' + key + '"]');
  }

  function placeAfter(key, target, config) {
    if (!target || alreadyPlaced(key)) return false;
    var banner = makeBanner(config);
    if (!banner) return false;
    banner.dataset.capHelpInstance = key;
    target.insertAdjacentElement('afterend', banner);
    return true;
  }

  function placeBefore(key, target, config) {
    if (!target || alreadyPlaced(key)) return false;
    var banner = makeBanner(config);
    if (!banner) return false;
    banner.dataset.capHelpInstance = key;
    target.insertAdjacentElement('beforebegin', banner);
    return true;
  }

  function placeInsideAfter(key, target, config) {
    if (!target || alreadyPlaced(key)) return false;
    var banner = makeBanner(config);
    if (!banner) return false;
    banner.dataset.capHelpInstance = key;
    target.insertAdjacentElement('afterend', banner);
    return true;
  }

  function init() {
    wireLinks(root);

    var homeCopy = {
      variant: 'home',
      eyebrow: 'Il Capitano ti dà una mano',
      title: 'Non trovi il prodotto che stai cercando?',
      body: 'Nessun problema: scrivi su WhatsApp e ti aiutiamo a trovare canne, mulinelli, esche, nautica e accessori giusti per te.'
    };

    var catalogCopy = {
      variant: 'catalog',
      eyebrow: 'Serve una mano nella ricerca?',
      title: 'Se il prodotto non salta fuori, ci pensa il Capitano.',
      body: 'Mandaci un messaggio WhatsApp con quello che cerchi: controlliamo disponibilità, alternative e articolo più adatto alla tua tecnica.'
    };

    var searchCopy = {
      variant: 'search',
      eyebrow: 'Ricerca assistita',
      title: 'Non riesci a trovare l’articolo?',
      body: 'Scrivi direttamente al Capitano: descrivi il prodotto, marca o tecnica e ti guidiamo noi nel catalogo.'
    };

    if (pageType === 'index' || document.body.classList.contains('template-index')) {
      // In home l'assistenza è integrata direttamente sotto la barra di ricerca dell'header.
      // Evitiamo quindi il banner grande sotto la prima sezione.
    }

    if (pageType === 'collection' || document.body.classList.contains('template-collection')) {
      var toolbar = document.querySelector('.cap-collection-toolbar');
      var gridContainer = document.getElementById('ProductGridContainer');
      placeAfter('collection-after-toolbar', toolbar, catalogCopy) || placeBefore('collection-before-grid', gridContainer, catalogCopy);
    }

    if (pageType === 'search' || document.body.classList.contains('template-search')) {
      var searchHero = document.querySelector('.cap-search-hero') || document.querySelector('.template-search__header');
      placeAfter('search-after-hero', searchHero, searchCopy);
    }

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
